import React, {useState, useEffect} from 'react';
import {useRouteMatch} from 'react-router-dom';
import classnames from 'classnames';
import AbstractDropdownView from 'common/components/AbstractDropdownView';
import viewHover from '../../assets/view_column-444444.svg';
import {pathnames as P} from 'common/constants/pathnames';
import config from '../../../config/common.json';
import styles from './styles.module.scss';

const Checkbox = ({
                    column,
                    checked: defaultChecked = true,
                    onChange,
                    onColumnChange,
                    disabled,
                    ...rest
                  }) => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_ID);
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = e => {
    onChange(e);
    setChecked(e.target.checked);
    onColumnChange({
      shumaId,
      columnName: column.id,
      display: e.target.checked ? 1 : 0
    });
  };

  return (
    <label className={styles.dropdownItem}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        className={styles.input}
        disabled={disabled}
        {...rest}
      />
      <div className={classnames(styles.checkbox, {
        [styles.checked]: checked,
        [styles.disabled]: disabled,
      })}
      />
      <div className={classnames(styles.labelContainer, {
        [styles.disabled]: disabled,
      })}>{column.Header}</div>
    </label>
  );
};

const DropdownSelectColumns = ({
                                 id,
                                 allColumns,
                                 list,
                                 onColumnChange,
                               }) => {
  const [columns, setColumns] = useState(null);
  const [limitIsReached, setLimitIsReached] = useState(false);

  const removeChecked = column => column.id !== 'checked';

  const toggleSavedColumns = column => {
    const {id: columnId, toggleHidden} = column;
    const savedColumns = list[id];
    const [currentSavedColumn] = savedColumns.filter(({columnName}) => columnName === columnId);
    if (currentSavedColumn) {
      toggleHidden(!currentSavedColumn.display); // need to pass value "is hidden"
    }
  };

  const isNotChecked = column => {
    return !column.getToggleHiddenProps().checked;
  };

  const prepareColumns = () => {
    const preparedColumns = allColumns.filter(removeChecked);
    preparedColumns.forEach(toggleSavedColumns);
    setColumns(preparedColumns);
  };

  const checkLimit = () => {
    const visibleColumns = list[id].filter(item => item.display);
    setLimitIsReached(visibleColumns.length >= config.step9SelectedColumnLimit);
  };

  useEffect(() => {
    prepareColumns();
  }, [allColumns, list]);

  useEffect(() => {
    checkLimit();
  }, [list]);

  const mapColumns = (column, ind) => (
    <Checkbox
      key={ind}
      column={column}
      onColumnChange={onColumnChange}
      disabled={limitIsReached && isNotChecked(column)}
      {...column.getToggleHiddenProps()}
    />
  );

  return Boolean(columns) && (
    <AbstractDropdownView
      subPath={`columns-${id}`}
      customContainerClassName={styles.ddMenu}
      triggerContent={({toggleDropdown}) => (
        <img src={viewHover} alt="view-column" onClick={toggleDropdown}/>
      )}
      dropdownContent={({closeDropdown}) => (
        <div className={styles.dropdownShow}>
          <div
            className={styles.dropdownHeader}
          >
            בחירת עמודות
          </div>
          {columns.map(mapColumns)}
        </div>
      )}
    />
  );
};

export default DropdownSelectColumns;